import PropTypes from "prop-types";
import { Dialog } from "@mui/material";
import { useCallback } from "react";
import AppSnackbar from "layouts/notifications/Snackbar";
import { useTranslation } from "hooks/useTranslation";
import { useDeleteUserFlow } from "hooks/useDeleteUserFlow";
import DeleteUserDialogBody from "components/DeleteUserDialogBody";

export default function DeleteUser({ open, onClose, user, onSuccess, title }) {
  const { t } = useTranslation();

  const filterAnnotatorsList = useCallback((data, userId) => {
    return data.filter((a) => a.id !== userId);
  }, []);

  const flow = useDeleteUserFlow({
    user,
    open,
    onClose,
    onSuccess,
    t,
    filterAnnotatorsList,
    superAdminContext: true,
  });

  const modalTitle = title || t("admin.annotators.modals.deleteAnnotator", "Delete Annotator");
  const lblReassign = t("admin.annotators.modals.messages.reassignSamples", "Re-Assign Samples To");
  const lblSelectAnnotator = t(
    "admin.annotators.modals.messages.selectAnnotator",
    "Select Annotator"
  );
  const btnProceed = t("admin.annotators.modals.buttons.proceed", "Proceed");
  const btnDiscard = t("admin.annotators.modals.buttons.discard", "Discard");

  return (
    <>
      <Dialog
        open={open}
        onClose={flow.loading ? undefined : flow.handleCancel}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { zIndex: (theme) => theme.zIndex.modal + 1 } }}
        BackdropProps={{ sx: { zIndex: (theme) => theme.zIndex.modal } }}
      >
        <DeleteUserDialogBody
          modalTitle={modalTitle}
          needsReassign={flow.needsReassign}
          lblReassign={lblReassign}
          lblSelectAnnotator={lblSelectAnnotator}
          lblConfirmDel={flow.lblConfirmDel}
          btnProceed={btnProceed}
          btnDiscard={btnDiscard}
          annotatorList={flow.annotatorList}
          selectedValue={flow.selectedValue}
          setSelectedValue={flow.setSelectedValue}
          loading={flow.loading}
          onProceed={flow.onProceed}
          onConfirm={flow.onConfirm}
          onCancel={flow.handleCancel}
        />
      </Dialog>
      <AppSnackbar
        type={flow.snackbar.type}
        message={flow.snackbar.message}
        open={flow.snackbar.open}
        onClose={flow.closeSnackbar}
      />
    </>
  );
}

DeleteUser.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]).isRequired,
  onSuccess: PropTypes.func,
  title: PropTypes.string,
};

DeleteUser.defaultProps = {
  title: null,
};
